import e from"react";const m=()=>e.createElement("div",{className:"bg-border my-xxs mx-sm h-px"});export{m as MenuDivider};
